import { formatTimeFromISO, adjustTime, formatTimeToHHMM, roundToNearest5Minutes } from './localeUtils';

/**
 * Met à jour les horaires variables en utilisant les zmanim
 * @param {Array} scheduleData - Les données d'horaires
 * @param {Object} zmanim - Les zmanim calculés
 * @param {Object} parasha - Les données de parasha (optionnel)
 * @param {string} language - La langue d'affichage
 * @param {Object} community - Les données de la communauté
 * @returns {Array} Les horaires mis à jour
 */
export const updateVariableTimes = (scheduleData, zmanim, parasha, language, community) => {
  if (!scheduleData || !zmanim) return scheduleData;

  const zmanMapping = {
    'Netz': 'neitzHachama',
    'Chatzot': 'chatzos',
    'MinhaGuedola': 'minchaGedola',
    'MinhaKetana': 'minchaKetana',
    'PlagHaMincha': 'plagHaMincha',
    'Shekia': 'shkiah',
    'Stars': 'tzeit',
    'CandleLighting': 'candleLighting',
    'Havdalah': 'havdalah'
  };

  const updatedSchedule = scheduleData.map(prayer => {
    if (prayer.isVariable === 1 && prayer.zman) {
      const zmanKey = zmanMapping[prayer.zman];
      const zmanTime = zmanim.zmanim[zmanKey] || parasha?.[zmanKey];
      if (zmanTime) {
        const baseTime = formatTimeFromISO(zmanTime, language);
        const adjustedTime = adjustTime(baseTime, prayer.offSetValue, language);
        let finalTime = formatTimeToHHMM(adjustedTime, language);
        
        if (prayer.around5m) {
          finalTime = roundToNearest5Minutes(finalTime);
        }
        
        return {
          ...prayer,
          time: finalTime
        };
      }
    }
    return {
      ...prayer,
      time: formatTimeToHHMM(prayer.time, language)
    };
  });

  return updatedSchedule;
}; 